import {yupNumber} from 'shared/web';

import i18n from '../../../i18n/i18n';
import {MIN_FIRST_REGISTRATION_YEAR} from '../constants/minFirstRegistrationYear';

const MESSAGE_KEY = 'page.create.validation.firstRegistrationOnYearMustBeOneOfOptions';

export function buildFirstRegistrationOnYearValidation(allowedYearValues: number[]) {
  return yupNumber
    .min(MIN_FIRST_REGISTRATION_YEAR, ({min, value}) =>
      i18n.t('page.create.validation.firstRegistrationOnYearMustBeAtLeast', {
        minYear: min,
        actualYear: value,
      })
    )
    .required()
    .oneOf(allowedYearValues, (params: {value: number}) =>
      i18n.t(MESSAGE_KEY, {
        value: params.value,
      })
    );
}
